import { IModifiedProductListItem, IProductListItem } from '../types';
import { NUMBER_OF_ROW } from './constants';
export const getProductListForDropdown = (
  productList: IProductListItem[]
): IProductListItem[] => {
  return productList.map((productListItem) => {
    return {
      ...productListItem,
      value: productListItem.value + productListItem.label,
    };
  });
};

export const getProductListDesktopData = (
  productList: IProductListItem[]
): IProductListItem[] => {
  const emptyObject: IProductListItem = { label: '', value: '' };
  const modular: number = NUMBER_OF_ROW - (productList.length % NUMBER_OF_ROW);
  const productListDesktop: IProductListItem[] = [];

  if (modular === NUMBER_OF_ROW) {
    return productListDesktop;
  }

  for (let i = 0; i < modular; i++) {
    productListDesktop.push(emptyObject);
  }
  return productListDesktop;
};

export const getModifiedListDesktopData = (
  productList: IProductListItem[]
): IModifiedProductListItem[] => {
  const groupedData: IModifiedProductListItem[] = [];
  const groups: { [key: string]: IModifiedProductListItem } = {};

  const uniqueProductList = productList.filter(
    (obj, index, arr) =>
      index ===
      arr.findIndex(
        (item) => item.label === obj.label && item.value === obj.value
      )
  );

  uniqueProductList.sort((a, b) => a.label.localeCompare(b.label));

  for (const item of uniqueProductList) {
    const firstChar = item.label.charAt(0).toUpperCase();

    if (!groups[firstChar]) {
      groups[firstChar] = { label: firstChar, items: [] };
      groupedData.push(groups[firstChar]);
    }
    groups[firstChar].items.push({ label: item.label, value: item.value });
  }
  return groupedData;
};
